import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import translate from '@i18n'
import FreeRatioImage from '@components/FreeRatioImage'

import {
  constraints as euromillionsLogoConstraints,
  euromillionsLogoImage,
} from './images/euromillionsLogo'
import {
  constraints as swissLottoLogoConstraints,
  swissLottoLogoImage,
} from './images/swissLottoLogo'

interface HeaderProps {
  title: 'Swiss Lotto' | 'EuroMillions'
  drawDate: string
  id: 'swisslotto' | 'euromillions'
}

const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const Title = styled.div`
  ${({
    theme: {
      typography: {
        headings: {
          medium: { bundledCSS: headingMediumCSS },
        },
      },
    },
  }) => css`
    ${headingMediumCSS};
  `}
`

const Date = styled.div`
  ${({
    theme: {
      typography: {
        bodycopy: {
          small2: { bundledCSS: bodycopySmall2CSS },
        },
      },
    },
  }) => css`
    ${bodycopySmall2CSS};
  `}
`

const Header: FunctionComponent<HeaderProps> = ({ title, drawDate, id }) => {
  return (
    <StyledHeader>
      <div>
        <Title>{title}</Title>
        <Date>
          {`${translate('lotto.drawingFrom', {
            drawDate: drawDate,
          })}`}
        </Date>
      </div>
      {id === 'swisslotto' ? (
        <FreeRatioImage
          src={swissLottoLogoImage.src}
          alt={swissLottoLogoImage.alt}
          originalDimensions={{
            width: swissLottoLogoImage.width,
            height: swissLottoLogoImage.height,
          }}
          crops={swissLottoLogoImage.crops}
          constraints={swissLottoLogoConstraints}
        />
      ) : (
        <FreeRatioImage
          src={euromillionsLogoImage.src}
          alt={euromillionsLogoImage.alt}
          originalDimensions={{
            width: euromillionsLogoImage.width,
            height: euromillionsLogoImage.height,
          }}
          crops={euromillionsLogoImage.crops}
          constraints={euromillionsLogoConstraints}
        />
      )}
    </StyledHeader>
  )
}

export default Header
